import { Injectable } from '@angular/core';
import { Validators } from '@angular/forms';

import { phoneNumberValidator } from '~/core/validators/phone-number.validator';
import { ToggleService } from '~/toggles/services/toggle.service';
import { ToggleNameEnum } from '~/toggles/services/toggle/enums/name.enum';

@Injectable({
  providedIn: 'root',
})
export class ValidatorsService {
  private readonly _defaultPattern = '.*';

  constructor(private readonly toggleService: ToggleService) {}

  public phoneNumber(localFormat): Validators[] {
    if (this.toggleService.isEnabled(ToggleNameEnum.ValidatorPhoneNumber)) {
      return [phoneNumberValidator(localFormat)];
    }
    return [];
  }

  public postalCode(): Validators[] {
    if (this.toggleService.isEnabled(ToggleNameEnum.ValidatorPostalCode)) {
      return [
        Validators.pattern(
          this.toggleService.getVariantString(
            ToggleNameEnum.ValidatorPostalCode,
            this._defaultPattern
          )
        ),
      ];
    }
    return [];
  }
}
